module.exports = __webpack_public_path__ + "img/error_sign.0704d49a.svg";